import { render, staticRenderFns } from "./WidgetReviewsGalleryMobile.vue?vue&type=template&id=645392b1"
import script from "./WidgetReviewsGalleryMobile.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsGalleryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports